import MvtLayer from './MvtLayer';
import mvtOsmStyle from '../../resources/mvt/osm-demo.mvt.json';
import { isOsmTestTileURL, MVT_OSM_TEST_URL } from './MvtLayerConfig';
import { MVT_PANE_Z_INDEX } from '../util/ZIndexes';

const config = {
    style: mvtOsmStyle,
    tileUrl: MVT_OSM_TEST_URL,
    isActive: isOsmTestTileURL,
    errorLabel: 'MVT OSM layer error',
    pane: 'mvtOsmPane',
    paneZIndex: MVT_PANE_Z_INDEX,
};

export default function MvtOsmLayer() {
    return <MvtLayer config={config} />;
}
